var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ProvinceTable"},[_c('my_table',{attrs:{"infos":_vm.infos,"titles":_vm.titles,"details":_vm.details}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }